const ITEMS = [
  "KEEP UP TO 95%",
  "$250 / MONTH FLAT",
  "NO LOCK-IN CONTRACT",
  "NO STARTUP FEES",
  "YOUR BRAND OR OURS",
  "LISTING TO SETTLEMENT, HANDLED",
];

export default function Marquee() {
  const strip = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="bg-[#111111] text-[#F9F8F6] border-y border-[#111111] py-4 overflow-hidden"
      aria-hidden
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex">
            {strip.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center text-xs uppercase tracking-[0.3em]">
                <span className="px-6">{item}</span>
                <span className="text-[#FF3B30]">/</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
